import React from "react";

import "./style.scss";

export const TermsAndConditionsText = () => {
	return (
		<div className="big-text">
			<h1>Terms and Conditions</h1>
			<ol>
				<li>
					<h2>Preamble</h2>
				</li>
				<p>
					TenPinCam Platform has been created to provide game facilities to the ten pin bowling players within the
					framework of sports and entertainment formats. The Platform is designed for the bowling development as a
					sport, accessible and uniting. The principle of TenPinCam project is based on the application of technical
					aids (video cameras, Internet network, user’s device) for online playing worldwide. The game scores depend
					exclusively on the player’s skills (Game of Skill). The users of the platform play bowling on lanes of bowling
					centres equipped with a set of TenPinCam video cameras, the game scores are recorded and controlled through
					the TenPinCam platform interface. The game is run in compliance with the rules of the World Bowling.
				</p>
				<li>
					<h2>Platform Users</h2>
					<ol>
						<li>TenPinCam Platform is designed for:</li>
						<li>professional players within the framework of participation in tournaments;</li>
						<li>amateurs as online play entertainment formats;</li>
						<li>bowling centres as provision of ancillary services to their clients and clientele expansion;</li>
						<li>referees within the framework of work on enforcement of compliance with the rules;</li>
						<li>tournament administrators within the framework of tournament management.</li>
					</ol>
				</li>
				<li>
					<h2>Key terms and definitions </h2>
					<ol>
						<li>
							Platform means the TenPinCam online system with the functionality to offer play facilities for bowling
							fans within the framework of sport and entertainment formats.{" "}
						</li>
						<li>
							User means a person, which has been registered and verified, who uses the Platform in pursuance of the
							concluded Service Agreement.{" "}
						</li>
						<li>
							Service means the activity implemented by the Platform as to the User, by applying the available
							functionality.
						</li>
						<li>Subscription means an agreement between the User and the Platform on the Service maintaining. </li>
						<li>Tariff means a fixed charge within the framework of a certain Subscription.</li>
						<li>Play means a bowling competition based on display of skills by the participants (game of skill). </li>
						<li>Game means a play consisting of 10 frames.</li>
						<li>Match means a play consisting of one or several games. </li>
						<li>
							Gaming session means the status of connection to the system during which one or more matches can be
							played.
						</li>
						<li>
							Alley means the equipped according to the technical specification lane in a bowling centre, which is the
							Platform User.
						</li>
						<li>
							System Administrator means a responsible person of the TenPinCam Platform, who manages the system
							operation.{" "}
						</li>
						<li>
							Money Prize – money prize paid by platform the User, according to the corresponding Tournament Schedule.{" "}
						</li>
					</ol>
				</li>
				<li>
					<h2>Subscription</h2>{" "}
					<ol>
						<li>The Platform Users are provided with certain subscription parameters depending on the Tariff.</li>
						<li>
							A Player may choose one of the offered Subscription type and corresponding Tariffs:
							<ol>
								<li>
									Tariff Premium:
									<ol>
										<li>Save & review records of your games.</li>
										<li>Available data storage - 10GB.</li>
										<li>Participation in Premium tournaments.</li>
										<li>
											The monthly fee is indicated in the Service interface at the time of payment. The user agrees to
											the automatic monthly payment until the automatic charging is canceled.
										</li>
									</ol>
								</li>
							</ol>
						</li>
						<li>
							A user has the right to choose none of the subscription types, by reserving access to the User Account and
							email box, furthermore, the opportunity to watch certain plays as a Viewer.
						</li>
						<li>A player may activate any Subscription type any time without restrictions.</li>
						<li>
							A player may opt-out of Subscription any time, by taking into consideration the restrictions (Refer to
							Service Cancellation Section).
						</li>
						<li>
							Upon activation of Subscription the funds are debited from the User’s e-wallet for the entire period of
							using the Service.
						</li>
						<li>
							After expiration of the subscription, it shall be extended automatically, unless the User has chosen
							another option.
						</li>
						<li>The subscription tariffs do not apply to such users as Referee, Bowling Centre.</li>
						<li>
							During the purchase of the Subscription the option Automatic Renewal works. In such case, the system will
							work in the following way:
							<ol>
								<li>
									On the last day of subscription, the system will automatically charge the user account for the next
									month
								</li>
								<li>
									If the charge was unsuccessful – the Automatic Renewal service will be canceled & access to the
									services will be closed. The user would have to purchase the new subscription to activate the
									services.
								</li>
							</ol>
						</li>
						<li>
							Subscription Service Cancellation.
							<ol>
								<li>
									The user is eligible to cancel the subscription Renewal service at any time by selecting the option in
									Subscriptions settings of Apple ID on IOS or in his account on Android. In case of the cancellation,
									the user can access the services until the last day of the paid subscription term. The user may also
									cancel the Automatic Renewal at any time.
								</li>
								<li>
									If the user has canceled the subscription, his data archive will be stored in the system for another
									30 days, after this term the data will be automatically deleted. Within 30 days after cancellation the
									user can purchase the subscription to restore the access to his data archive.
								</li>
							</ol>
						</li>
					</ol>
				</li>
				<li>
					<h2>Registration</h2>
					<ol>
						<li>To get a User status it is necessary to register on the Platform. </li>
						<li>
							At registration, it is necessary to specify all personal data requested by the system (Refer to Personal
							Data Protection Section), download the User’s photo, also specify the User name in the system and the
							password.
						</li>
						<li>
							For full – featured registration it is recommended to specify additional data in the player’s
							questionnaire.
						</li>
						<li>
							At registration a User needs to get acquainted with these rules, as well as with the Cancellation Policy,
							Privacy Policy and accept thereof.
						</li>
						<li>
							For registration a User may specify own data only. If it is established that a third – party data was used
							at registration, the System Administrator is eligible to lockdown the profile and void all activities on
							the Platform
						</li>
						<li>
							Users are allowed to register one profile only. If it is established that more than one profile belongs to
							the User, the System Administrator shall be eligible to lockdown the profile and void all activities on
							the Platform.
						</li>
						<li>
							Once all of the necessary data have been completed, the registration inquiry shall be sent for
							verification (Refer to User Verification Section).
						</li>
					</ol>
				</li>
				<li>
					<h2>User Verification </h2>
					<ol>
						<li>To complete registration the Player’s application is to be confirmed by the System Administrator. </li>
						<li>The Player verification process can take up to several working days. </li>
						<li>
							Where any doubts appear on truthfulness of information entered, the System Administrator shall be at
							liberty to request the player to submit additional data
						</li>
						<li>
							The System Administrator reserves the right to refuse verification of a User without assigning any reason
						</li>
						<li>Verification of bowling centres (cameras, Internet) is performed by the System Administrator.</li>
					</ol>
				</li>
				<li>
					<h2>Profile Activation</h2>
					<ol>
						<li>Upon successful verification the User profile shall be activated.</li>
						<li>
							At activation of the profile the User shall be assigned the initial rating (Refer to Rating Section).
						</li>
						<li>
							All of the Platform opportunities, as per the tariff chosen, become available upon activation of the
							profile.
						</li>
					</ol>
				</li>
				<li>
					<h2>User Account </h2>
					<ol>
						<li>A User Account page is available to all registered users with an activated profile.</li>
						<li>A User Account may be used only by the person who has registered this profile. </li>
						<li>
							A user undertakes to keep secret the access password to the User Account and not disclose thereof to third
							parties
						</li>
						<li>
							If the profile is hacked, the User is to contact the System Administrator forthwith with a request to
							lockdown the profile for further investigation.
						</li>
						<li>If a password is lost, the User may use the recovery function. </li>
						<ol>
							A User Account consists of the following information:
							<ol>
								<li>Personal data – questionnaire details of the user;</li>
								<li>
									My Games – information concerning user’s games (archive), pending applications for plays from
									opponents, current created tournaments.
								</li>
								<li>
									Bowling centres – information concerning bowling centres where the Platform opportunities are
									accessible.
								</li>
								<li>
									Email box – notification system, administrators of tournaments and referees, decisions on protests,
									communication between the players
								</li>
							</ol>
						</ol>
					</ol>
				</li>
				<li>
					<h2>Playing games</h2>
					<ol>
						<li>
							The Platform game window consists of:
							<ol>
								<li>Camera block </li>
								<li>Scoring block </li>
								<li>Chat block </li>
								<li>Settings block </li>
							</ol>
						</li>
						<li>
							n Battles the camera block consists of three images of cameras of an opponent that are directed
							accordingly at the pinsetter, scores screen and at the tournament area, as well as the same pictures of
							the Player’s cameras. The block implies a possibility to switch between cameras of the Player and cameras
							of the fellow player, furthermore, to use a video archive. The scores screen can be integrated into the
							Platform.{" "}
						</li>
						<li>
							The Scoring block represents the tournament results of the Player. The scoring block of the opponent is
							included when the game format is a Battle.
						</li>
						<li>
							The Chat block contains notifications of the Platform, furthermore, implies a possibility of interactions
							between the Users
						</li>
						<li>
							The gameplay in any format implies an online game, completion of forms of own scores and mutual control
							between opponents.
						</li>
						<li>
							In Battle format the Players bowl in turns, one frame at a time. While the Player is bowling, the fellow
							player can watch the process on cameras.
						</li>
						<li>
							Once bowled, the Player has to enter his scores to the relevant block and confirm its correctness by
							clicking on “Save” button
						</li>
						<li>
							Where the score was entered wrongly until confirmation, it can be corrected, by re-entering correct data.{" "}
						</li>
						<li>
							Where the score is entered wrongly and has been confirmed, it can be corrected at any time of the game, by
							adding comments. In Battle format thereafter the fellow player shall be notified of the correction. The
							fellow player, in his turn, can agree to the correction or disagree (Refer to Protests Section).
						</li>
						<li>
							In Battle format once the scores of the Player have been entered and confirmed the turn goes over to the
							opponent.
						</li>
						<li>
							The sequence of bowling is monitored by the Platform. The Player receives audio and visual notification
							that the turn has come over to him.
						</li>
						<li>
							For each frame (the 10th frame inclusive) the Player is given the time limit which depends on the Match
							format. During this period the Player must complete his frame, enter his score and confirm it. If the
							format is Battle the Player also must ensure the correctness of the entered score of the preceding frame
							of the opponent.
						</li>
						<li>
							Where the Player fails to confirm the frame score in time subject to the rules, upon expiry of the time
							the Player receives a yellow card. In case of a repeated delay of frame in excess of 5 minutes (after
							receiving a yellow card in the same frame or in any other subsequent shots of this game) the Player shall
							receive a defeat.
						</li>
						<li>
							Where the Player fails to complete the frame in time subject to the rules, upon expiry of the time the
							Player receives a yellow card and additional 5 minutes to complete the frame. If this card is already the
							second one in this frame or the Player fails to complete the frame within the additional time limit, the
							Player shall receive a defeat.
						</li>
						<li>
							Where the reason for such delay was a malfunction, the time-out rule shall take effect (Refer to
							Malfunction Section).
						</li>
					</ol>
				</li>
				<li>
					<h2>Alley</h2>
					<ol>
						<li>
							One or several lanes in the bowling alley has to be equipped with the TenPinCam certified camera system
							subject to the rules. A set of equipment is provided to a bowling centre by the TenPinCam Platform subject
							to agreement on a case-by-case basis. In a bowling centre on at least one or several lanes the below set
							of equipment is to be installed:
							<ol>
								<li>
									The WiFi access point named TenPinCam.com, with the video cameras connected through this point.{" "}
								</li>
								<li>General View camera. </li>
								<li> Pinsetter camera. </li>
								<li>
									Scoring camera. In case the bowling center scoring system is integrated with the TenPiCam platform,
									the Scoring Camera is not required
								</li>
							</ol>
						</li>
						<li>
							The lane oil pattern is not regulated and can be used in whatever configuration at the discretion of the
							Player.
						</li>
						<li>
							The lane coating cannot be performed during the game session. In the Match consists of several games, the
							lane coating cannot be performed between the games.
						</li>
						<li>
							An operative foul line is not a compulsory condition for the alley. Nevertheless, if a foul is noted by a
							fellow player and can be distinguished on cameras, the result of a shot shall not be counted.{" "}
						</li>
						<li>
							The change of the ball surfaces is not regulated and can be used any time of a game at the discretion of
							the Player.
						</li>
						<li>The players uniform is not regulated.</li>
					</ol>
				</li>
				<li>
					<h2>Malfunction</h2>
					<ol>
						<li>
							Malfunction implies one of the listed below
							<ol>
								<li>Stop (switching off) of a lane </li>
								<li>Inoperative scoreboard screen </li>
								<li>Inoperative camera </li>
								<li>Lost connection, network failure </li>
								<li>Other malfunctions</li>
							</ol>
						</li>
						<li> In case of a technical failure the Player may ask a technical time-out</li>
						<li>
							Upon correction of the malfunction, the match shall be resumed by preserving all standard time limits.{" "}
						</li>
						<li>
							In case of a repeated malfunction during one and the same game, such malfunction must be rectified within
							5 minutes dedicated to complete the frame.
						</li>
						<li>
							Where it is impossible to rectify a malfunction within the time established, the Player shall receive a
							defeat. It is not allowed to transfer the game to another lane or replay the match.
						</li>
						<li>
							Responsibility for the technical condition of the alley rests with the Player. The Platform bears no
							responsibility for the consequences as a result of malfunctions of alleys.
						</li>
					</ol>
				</li>
				<li>
					<h2>Disciplinary Responsibility</h2>
					<ol>
						<li>
							During a game session, the Users are prohibited to:
							<ol>
								<li>Insult other Users in the chat, also to use rude gestures.</li>
								<li>
									Incite the fellow player to cheating, manipulation of scores, any other violation of game rules.
								</li>
								<li> Disregard other rules of the regulation.</li>
							</ol>
						</li>
						<li>
							In case of violation of any of the rules the Player shall receive a defeat in the entire match. The
							Player’s case shall be submitted for consideration to the Disciplinary Committee, where the
							disqualification matter shall be considered.
						</li>
						<li>During the play the Player shall follow the Fair Play principles</li>
						<li>
							The Disciplinary Committee consists of the System Administrator, Head of the Referee’s Committee, as well
							as of all referees of tournaments, if any.{" "}
						</li>
					</ol>
				</li>
				<li>
					<h2>Protests</h2>
					<ol>
						<li>Protests are considered in two modes – online and offline – depending on the tournament settings. </li>
						<li>
							Protests are considered in the Battle mode and in Tournaments matches.Where a protest is lodged, the
							fellow player receives a notification. If a protest concerns correction of the score and the fellow player
							agrees with the statement, then after correction the Platform offers the Players to confirm the match
							result again
						</li>
						<li>
							Where a protest is considered in an offline mode, the Referee shall take a decision within 48 hours and
							communicate his decision to the Players.
						</li>
						<li>
							Where a protest is considered in an online mode, the Referee shall take a decision within 15 minutes and
							communicate his decision to the Players. In such event the Referee’s decision shall not subject to appeal
						</li>
					</ol>
				</li>
				<li>
					<h2>Battle Format </h2>
					<ol>
						<li>The Battle format offers an opportunity to two Players to compete against each other. </li>
						<li>A Player may create own Battle or participate in already created one. </li>
						<li>Just two Players can participate in one Battle. </li>
						<li>One Player can simultaneously participate in one Battle only.</li>
						<li>
							At the creation of a Battle the Player chooses the following parameters:
							<ol>
								<li>Number of wins is the number of games to be won to win the Battle – from 1 to 5. </li>
								<li>
									Date and time of play
									<ol>
										<li>Now – the Battle is accessible to opponents immediately after confirmation of settings;</li>
										<li>Choose another date – the Battle is accessible as from the time specified.</li>
									</ol>
								</li>
							</ol>
						</li>
						<li>
							In creation of a Battle the Player has to choose the Bowling Centre and the lane from among the offered
							list, on which he is going to play.
						</li>
						<li>
							Once the Battle has been created, it appears on the general list of accessible games, also the Battle Game
							List reflects completed games.
						</li>
						<li>
							The Battle Game List reflects the game creator, his rating, the quantity of games and comments of the
							Battle creator.
						</li>
						<li>
							A Player, who wishes to participate in already created Battle, can choose one Battle from among the
							general game list and send the invitation.{" "}
						</li>
						<li>
							A Player, who has created the Battle, may accept or deny the invitation received. Where the invitation is
							accepted, the Battle becomes inaccessible for other Players and disappears from the general game list.
							Where the invitation is rejected, the Battle remains accessible for the Players.{" "}
						</li>
						<li>
							In the battle format no tie score is allowed – in case of a tie score in 10 frames the 10th shot shall be
							canceled, and the Platform shall appoint a play-off.{" "}
						</li>
					</ol>
				</li>
				<li>
					<h2>Tournaments format</h2>
					<ol>
						<li>The Tournament format offers an opportunity to many Players to compete against each other. </li>
						<li>A Player may create his own Tournament (Open Challenge) or participate in already created one.</li>
						<li>The tournament can be organized by the Platform or any Player. </li>
						<li>One Player can simultaneously participate in one Tournament only. </li>
						<li>
							To participate in Tournaments the Player has to choose the Bowling Centre and the lane from among the
							offered list, on which he is going to play.
						</li>
						<li>
							Once the Tournament has been created, it appears on the general list of accessible games, also the
							Tournaments List reflects completed ones.
						</li>
						<li>
							The Tournaments contain the rules and full description in the information section: dates, number of games,
							total number of entries.
						</li>
					</ol>
				</li>
				<li>
					<h2>Rating</h2>
					<ol>
						<li>
							Within the Platform framework the basic personal rating (PR) and activity rating (AR) apply to each role
							of the Users. For certain roles there is also the qualifying rating (QR).
						</li>
						<li> Within the Platform framework there is a system of achievements.</li>
						<li>The Platform affords also informal statistical ratings (average score, wins in tournaments etc.). </li>
						<li>The personal rating of a Player consists of the average assessment by other Players, from 0 to 5. </li>
						<li>
							After each match a Player may assess the fellow player according to the scale from 0 to 5, by taking into
							consideration the ethics of play and conduct of the fellow player. At the stage of activation of the
							Player’s profile the assessment by the opponent is a compulsory condition.{" "}
						</li>
						<li>
							The Platform affords the opportunity to leave more complete testimonial on the fellow player after the
							play, by using a designated form.{" "}
						</li>
					</ol>
				</li>
				<li>
					<h2>Platform Rights</h2>
					<ol>
						<li>The Platform has the right to send Users information by e-mail.</li>
						<li>
							The Platform is an owner of the video archive and has the right to place video of the games or the
							fragments in its social networks and on website www.tenpincam.com.
						</li>
					</ol>
				</li>
			</ol>
		</div>
	);
};
